import {
    MULTI_CHOICE_MUTATION_DEBOUNCE_DURATION,
    MUTATION_DEBOUNCE_MAX_DURATION,
} from '../debounce';
import useDebouncedState from '../useDebouncedState';
import { useUpdateField } from '../useUpdateField';
import { useBriefSetMultiGridChoiceMutation } from './briefSetMultiGridChoice.generated';

export function useUpdateMultiGridChoiceField(
    key: string,
    briefId?: string,
    initialValue?: string[]
) {
    const [setMultiGridChoice] = useBriefSetMultiGridChoiceMutation();

    return useDebouncedState(
        useUpdateField<string[] | string>({
            key,
            setField: setMultiGridChoice,
            briefId,
            initialValue: initialValue || [],
        }),
        MULTI_CHOICE_MUTATION_DEBOUNCE_DURATION,
        MUTATION_DEBOUNCE_MAX_DURATION
    );
}
